/**
 * 配置数据获取类
 */
//读取env配置文件 加载地址
import env from "../../env";
let cfg = {
    token_header_key: 'Authorization',   // http header 中存 token 的头
    // project_name    : '呼吸慢病科研平台',   // 项目的中文标题
    project_name    : 'eCRF病例管理科研平台',   // 项目的中文标题
    build_no        : 1,                 // 构建号
    ...env,
};
export default new Proxy(cfg, {
    /**
     * 获取属性
     */
    get: (target, propKey) => {
        if (propKey in target) {
            return target[propKey];
        } else {
            throw new ReferenceError('property ' + propKey + ' does not exist');
        }
    },

    /**
     * 设置属性
     * @param {Object} target - 目标对象
     * @param {String} propKey - 属性名
     * @param {Any} value - 属性值
     */
    set: (target, propKey, value) => {
        // 这里允许设置任何属性（包括新增属性或修改现有属性）
        target[propKey] = value;
        return true; // 必须返回 true 表示设置成功
    },

    /**
     * 检查属性是否存在
     * 添加这个方法是为了确保 'propKey in target' 在 Proxy 中能正确工作
     */
    has: (target, propKey) => {
        return propKey in target;
    }
});